import { SymbolInfo } from './../../../../types/drawing/symbol-set';
import { IconSymbols } from 'app/types/drawing/symbol-set';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnInit, ElementRef } from '@angular/core';

@Component({
  selector: 'app-attribute-option-point-swatch',
  templateUrl: './attribute-option-point-swatch.component.html',
  styleUrls: ['./attribute-option-point-swatch.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class AttributeOptionPointSwatchComponent implements OnInit {
  private _ready = false;
  public css: string = '';

  @HostBinding('attr.tabindex') tabIndex:number = 0;

  private _symbol?: SymbolInfo;
  @Input()
  set symbol(sym: SymbolInfo | undefined) {
    this._symbol = undefined;
    if(sym === undefined) return;

    this._symbol = sym;
    this.css = sym.css;
    this.Refresh();
  }
  get symbol():SymbolInfo | undefined {
    return this._symbol;
  }
  private _color:string = '#000';
  @Input()
  set color(clr:string) {
    this._color = clr;
    this.Refresh();
  }
  get color():string {
    return this._color;
  }
  constructor(private cdr: ChangeDetectorRef,private domNode:ElementRef) { }

  ngOnInit(): void {
    this.domNode.nativeElement.addEventListener('keydown',(event:KeyboardEvent)=>{
      event.preventDefault();
      if(event.cancelable) {
        event.cancelBubble = true;
      }
      event.stopImmediatePropagation();
    });
    this._ready = true;
  }
  Focus() {
    this.domNode.nativeElement.focus({preventScroll:true});
  }
  Refresh() {
    if (this._ready === true) {
      this.cdr.detectChanges();
    }
  }

}
